import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { StoresService } from 'src/app/core/stores.service';

@Component({
  selector: 'app-stores-sales-network-dialog',
  templateUrl: './stores-sales-network-dialog.component.html',
  styleUrls: ['./stores-sales-network-dialog.component.scss'],
})
export class StoresSalesNetworkDialogComponent {
  store_id: string;
  store_sales_network_id: string;
  set_sales_network_form_group: FormGroup = this.form_service.set_sales_network_form_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  is_store_edit_running: boolean = false;

  constructor(
    private readonly dialog_ref: MatDialogRef<StoresSalesNetworkDialogComponent>,
    private readonly form_service: FormService,
    private readonly stores_service: StoresService,
    private readonly error_service: ErrorService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.store_id = data.store_id;
    this.store_sales_network_id = data.store_sales_network_id;
  }

  ngOnInit(): void {
    this.set_sales_network_form_group
      .get(this.form_service.sales_network_id_label)
      ?.setValue(this.store_sales_network_id);
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onConfirmClick(): void {
    if (this.isFormValid()) {
      const sales_network_id = this.set_sales_network_form_group.get(this.form_service.sales_network_id_label)?.value;
      this.setSalesNetworkId(this.store_id, sales_network_id);
    }
  }

  setSalesNetworkId(store_id: string, sales_network_id: string): void {
    this.is_store_edit_running = true;
    this.stores_service.setSalesNetworkId(store_id, sales_network_id).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_store_edit_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_store_edit_running = false;
      },
    });
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.set_sales_network_form_group);
  }
}
